import React from 'react';

export const PRICING_FEATURES = [
  { name: 'Idea Discovery & Specs', free: true, hobbyist: true, pro: true, enterprise: true },
  { name: 'Features & Stories', free: true, hobbyist: true, pro: true, enterprise: true },
  { name: 'Unlimited Ideas & Plans', free: true, hobbyist: true, pro: true, enterprise: true },
  { name: 'Download Gallery', free: false, hobbyist: true, pro: true, enterprise: true },
  { name: 'AI Starter Bundle', free: false, hobbyist: true, pro: true, enterprise: true },
  { name: 'AI Chat', free: false, hobbyist: true, pro: true, enterprise: true },
  { name: 'Jira & Trello Integration', free: false, hobbyist: false, pro: true, enterprise: true },
  { name: 'GitHub Drift Detection', free: false, hobbyist: false, pro: true, enterprise: true },
  { name: 'SSO / SAML', free: false, hobbyist: false, pro: false, enterprise: true },
  { name: 'Custom Integrations', free: false, hobbyist: false, pro: false, enterprise: true },
  { name: 'Priority Support', free: false, hobbyist: false, pro: false, enterprise: true },
  { name: 'SLA Guarantee', free: false, hobbyist: false, pro: false, enterprise: true },
];

const T = {
  ink:       '#2E2109',
  inkMuted:  '#6E5A38',
  inkFaint:  '#A39068',
  rule:      '#D7C9A1',
  ruleStrong:'#BFAB79',
  moss:      '#6B7A3E',
  orange:    '#EA7C1F',
  capRed:    '#C14A33',
  card:      '#FFFBEC',
  paperDeep: '#EEE2BF',
};

const CheckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={T.moss} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5"/>
  </svg>
);

const XIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={T.inkFaint} strokeWidth="2" strokeLinecap="round">
    <path d="M18 6L6 18M6 6l12 12"/>
  </svg>
);

const PricingComparisonTable = () => (
  <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: '"Nunito", ui-sans-serif, system-ui, sans-serif' }}>
    <thead>
      <tr style={{ backgroundColor: T.paperDeep, borderBottom: `1px solid ${T.ruleStrong}` }}>
        <th style={{
          padding: '16px 24px',
          textAlign: 'left',
          color: T.ink,
          fontWeight: 700,
          fontSize: 14,
          letterSpacing: '0.02em',
          textTransform: 'uppercase',
        }}>
          Feature
        </th>
        {[
          { label: 'Free', highlight: false },
          { label: 'Hobbyist', highlight: false },
          { label: 'Pro', highlight: true },
          { label: 'Enterprise', highlight: false },
        ].map(({ label, highlight }) => (
          <th key={label} style={{
            padding: '16px',
            textAlign: 'center',
            color: highlight ? T.orange : T.ink,
            fontWeight: 700,
            fontSize: 14,
            letterSpacing: '0.02em',
            textTransform: 'uppercase',
            backgroundColor: highlight ? T.orange + '12' : 'transparent',
          }}>
            {label}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {PRICING_FEATURES.map((feature, index) => {
        const isLast = index === PRICING_FEATURES.length - 1;
        const isEven = index % 2 === 0;
        return (
          <tr
            key={index}
            style={{
              borderBottom: isLast ? 'none' : `1px solid ${T.rule}`,
              backgroundColor: isEven ? T.card : T.card + 'CC',
            }}
          >
            <td style={{
              padding: '14px 24px',
              color: T.ink,
              fontSize: 15,
              fontWeight: 500,
            }}>
              {feature.name}
            </td>
            {['free', 'hobbyist', 'pro', 'enterprise'].map((tier) => (
              <td
                key={tier}
                style={{
                  padding: '14px 16px',
                  textAlign: 'center',
                  backgroundColor: tier === 'pro' ? T.orange + '08' : 'transparent',
                }}
              >
                {feature[tier] ? <CheckIcon /> : <XIcon />}
              </td>
            ))}
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default PricingComparisonTable;
